import { MenuItem as MuiMenuItem, TextField, Popover } from "@mui/material";

import { styled } from "@mui/material/styles";

export const StyledTextfield = styled(TextField)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  height: "40px",
  maxWidth: "280px",
  justifyContent: "center",
  "& .MuiInputBase-root": {
    padding: "10px",
    flexWrap: "nowrap",
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
  },
  "& .MuiInputBase-input.MuiInput-input": {
    width: "85%",
  },
  "& .MuiInput-input.Mui-disabled": {
    WebkitTextFillColor: theme.palette.text.primary,
  },
  "& .MuiInputAdornment-root.MuiInputAdornment-positionStart": {
    "& p": {
      fontSize: theme.typography.body1.fontSize,
      color: theme.palette.text.secondary,
      minWidth: "fit-content",
      lineHeight: "1rem",
    },
  },
  "& p": {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "break-spaces",
    WebkitLineClamp: 2,
  },
}));

export const Menu = styled(Popover)(({ theme }) => ({
  "& .MuiPaper-root": {
    zIndex: 100000,
    minWidth: "280px",
    maxHeight: "400px",
    padding: "10px",
    backgroundColor: theme.palette.background.default,
  },
}));

export const MenuItem = styled(MuiMenuItem)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  margin: "10px 0",
  borderRadius: "5px",
  transition: "all .3s ease",

  "&.Mui-selected": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,

    "&:hover": {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
    },
  },
}));
